import { IClassname } from '@/lib/shared/model';

export const Manager = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14444_394)">
        <path
          d="M30.6959 30.6965V29.4185C30.6954 28.3774 30.377 27.3612 29.7832 26.506C29.1894 25.6507 28.3487 24.9972 27.3734 24.6327L21.1116 22.5293"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8883 22.5293L4.62654 24.6327C3.65123 24.9972 2.81045 25.6507 2.21669 26.506C1.62292 27.3612 1.30448 28.3774 1.30396 29.4185V30.6965"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9743 21.7504C17.7519 21.7504 21.725 19.5511 22.2962 16.1723C22.3308 15.9654 22.4158 15.7702 22.5438 15.6039C22.6717 15.4376 22.8386 15.3054 23.0297 15.2189C24.4111 14.5928 24.7575 12.0855 23.6418 11.527C24.2808 7.71119 24.2808 1.30371 15.9743 1.30371C7.66787 1.30371 7.66787 7.71119 8.30683 11.527C7.18993 12.0855 7.54008 14.594 8.91895 15.2189C9.11008 15.3054 9.27697 15.4376 9.40489 15.6039C9.53282 15.7702 9.61785 15.9654 9.65248 16.1723C10.2186 19.5511 14.1955 21.7504 15.9743 21.7504Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1662 30.6964L10.1829 22.7656"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.73306 23.5869L6.06282 26.9299C5.98691 27.0814 5.97428 27.2569 6.02773 27.4177C6.08117 27.5785 6.1963 27.7115 6.3478 27.7874L7.6845 28.4558C7.76549 28.4962 7.83696 28.5534 7.89417 28.6236C7.95138 28.6938 7.99302 28.7753 8.01634 28.8628C8.03966 28.9503 8.04413 29.0417 8.02944 29.1311C8.01475 29.2204 7.98124 29.3056 7.93114 29.381L7.05448 30.696"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2668 23.5869L25.937 26.9299C26.0129 27.0814 26.0255 27.2569 25.9721 27.4177C25.9186 27.5785 25.8035 27.7115 25.652 27.7874L24.3153 28.4558C24.2343 28.4962 24.1629 28.5534 24.1056 28.6236C24.0484 28.6938 24.0068 28.7753 23.9835 28.8628C23.9602 28.9503 23.9557 29.0417 23.9704 29.1311C23.9851 29.2204 24.0186 29.3056 24.0687 29.381L24.9453 30.696"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8337 30.6964L21.8171 22.7656"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8914 24.3066C17.8914 24.815 17.6894 25.3026 17.3299 25.6621C16.9704 26.0216 16.4829 26.2235 15.9745 26.2235C15.4661 26.2235 14.9785 26.0216 14.6191 25.6621C14.2596 25.3026 14.0576 24.815 14.0576 24.3066"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 30.6956L15.3865 26.1309"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.917 30.6963L16.6084 26.1162"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.11401 10.003C9.94926 9.21885 11.5346 7.94687 12.6979 6.3252C13.7077 7.36572 14.9162 8.19274 16.2518 8.75714C17.5874 9.32154 19.0228 9.61181 20.4727 9.61072C21.6324 9.60963 22.7844 9.42238 23.8848 9.0561"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 17.2783C14.5998 17.7705 15.2862 18.0451 15.9999 18.0451C16.7136 18.0451 17.3999 17.7705 17.9168 17.2783"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7221 12.1664C14.5867 11.9543 14.3964 11.7829 14.1714 11.6704C13.9464 11.5578 13.695 11.5084 13.4442 11.5274C13.1933 11.5084 12.942 11.5578 12.717 11.6704C12.4919 11.7829 12.3016 11.9543 12.1663 12.1664"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8337 12.1664C19.6983 11.9543 19.508 11.7829 19.283 11.6704C19.0579 11.5578 18.8066 11.5084 18.5557 11.5274C18.3049 11.5084 18.0536 11.5578 17.8285 11.6704C17.6035 11.7829 17.4132 11.9543 17.2778 12.1664"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14444_394">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
